import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CalendarDays, Car, Ellipsis, House, Users } from 'lucide-react'

import { tabForPathname, TENANT_TABS, type TenantTab } from './tabs'

const RAIL_ICONS: Record<TenantTab, typeof House> = {
  today: House,
  schedule: CalendarDays,
  customers: Users,
  vehicles: Car,
  more: Ellipsis,
}

/**
 * Desktop left rail (DESIGN.md §4.4): 236px sticky column, ≥1024px only.
 * Nav items 42px min-height / 10px radius; active = surface ground + ink
 * text + saved-deep icon. Identity (logo, agent dot, user menu) stays in
 * the top strip (§5), so the rail is nav only.
 */
export function SideRail() {
  const { t } = useTranslation('shell')
  const location = useLocation()
  const active = tabForPathname(location.pathname)

  return (
    <nav
      aria-label={t('tab.aria_label')}
      className="sticky top-0 hidden h-dvh w-[236px] flex-col gap-0.5 border-r border-border bg-background px-3 py-[18px] lg:flex"
    >
      {TENANT_TABS.map(({ key, to }) => {
        const Icon = RAIL_ICONS[key]
        const isActive = active === key
        return (
          <Link
            key={key}
            to={to}
            aria-current={isActive ? 'page' : undefined}
            className={`flex min-h-[42px] items-center gap-[11px] rounded-[10px] px-3 text-[15px] font-medium transition-colors ${
              isActive
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground [@media(hover:hover)_and_(pointer:fine)]:hover:bg-muted [@media(hover:hover)_and_(pointer:fine)]:hover:text-foreground'
            }`}
          >
            <Icon
              className={`size-[18px] ${isActive ? 'text-saved-deep' : 'text-ink-3'}`}
              strokeWidth={2}
            />
            {t(`tab.${key}`)}
          </Link>
        )
      })}
    </nav>
  )
}
